"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../context");
const MediaContainer_1 = tslib_1.__importDefault(require("../MediaContainer/MediaContainer"));
const styles_1 = require("../../../ui-lib/MediaWrapper/styles");
const ErrorBoundary_1 = require("../../ErrorBoundary");
const MediaWrapper_1 = tslib_1.__importDefault(require("../../../ui-lib/MediaWrapper"));
function MultistreamMediaContainer({ classes, children }) {
    var _a;
    const ctx = (0, react_1.useContext)(context_1.MultistreamContext);
    const { offsetHeight, offsetWidth } = (_a = ctx === null || ctx === void 0 ? void 0 : ctx.playersWrapperElement.current) !== null && _a !== void 0 ? _a : { offsetHeight: 0, offsetWidth: 0 };
    const defaultStyles = (0, react_1.useMemo)(() => {
        var _a;
        return (0, styles_1.getVideoElementStyles)({
            containerHeight: offsetHeight,
            containerWidth: offsetWidth,
            playersCount: (_a = ctx === null || ctx === void 0 ? void 0 : ctx.activePublicKeys.length) !== null && _a !== void 0 ? _a : 0,
        });
    }, [ctx === null || ctx === void 0 ? void 0 : ctx.activePublicKeys.length, offsetHeight, offsetWidth]);
    return (react_1.default.createElement(MediaContainer_1.default, { classes: {
            root: {
                ...defaultStyles.root,
                ...classes === null || classes === void 0 ? void 0 : classes.root,
            },
        } }, children));
}
/**
 *
 * @visibleName Multistream Media Container
 */
// eslint-disable-next-line react/function-component-definition
const MultistreamMediaContainerWithErrorBoundary = ({ classes, ...props }) => {
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => react_1.default.createElement(MediaWrapper_1.default, { classes: classes, ...props }) },
        react_1.default.createElement(MultistreamMediaContainer, { classes: classes, ...props })));
};
exports.default = MultistreamMediaContainerWithErrorBoundary;
//# sourceMappingURL=MultistreamMediaWrapper.js.map